export class Feature {
    featureId: string;
    timeStamp: number;
    name: string;
    internalName?: string;
    available:boolean;
    permissions: any;
    apiData: any;
    data: any;
}